module.exports = __webpack_public_path__ + "static/img/2.875a7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/2.png
// module id = 9dXP
// module chunks = 4